// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scale-wrapper {
    position: relative;
    margin-left: 10px;
    margin-right: 10px;
}

.scale-wrapper.scale-wrapper-card-based {
    margin-left: 0;
    margin-right: 0;
}


.scale-wrapper.scale-wrapper-top-border {
    border-top: solid 1px var(--survey-border-color);
}

.scale-wrapper .scale-header {
    text-transform: uppercase;
    font-size: 14px;
    text-align: left;
    padding: 10px;
    padding-left: 0px;
    white-space: pre-wrap;
}

.scale-wrapper .selected-value-display {
    font-size: 40px;
    height: 45px;
    line-height: 55px;
    text-align: center;
}

.scale-wrapper .value {
    position: absolute;
    overflow: hidden;
    text-overflow: ellipsis;
}

.scale-wrapper .scale-horizontal,
.scale-wrapper .scale-vertical {
    position: relative;
}

.scale-wrapper .scale-vertical:focus {
    outline-offset: 10px;
}

.scale-wrapper .scale {
    position: relative;
}

.scale-wrapper .scale .answer-marker-wrapper {
    position: absolute;
    width: 0px;
    height: 0px;
}

.scale-wrapper .scale .answer-marker-wrapper .answer-marker {
    position: absolute;
    height: 26px;
    width: 26px;
    border-radius: 13px;
    box-shadow: 0px 2px 5px #aaa;
    background: #FFF;
    z-index: 1;
    pointer-events: none;
    top: -13px;
    left: -13px;
}

.scale-wrapper .scale .scale-line-wrapper {
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.scale-wrapper .scale .scale-line-wrapper .click-area {
    position: absolute;
    z-index: 1;
}

.scale-wrapper .scale-horizontal .value {
    top: 0;
    width: 60px;
    height: 60px;
    line-height: 60px;
}

.scale-wrapper .scale-horizontal .value.min-value {
    left: 10px;
    text-align: left;
}

.scale-wrapper .scale-horizontal .value.max-value {
    right: 10px;
    text-align: right;
}

.scale-wrapper .scale-horizontal .scale {
    height: 60px;
    margin-left: 60px;
    margin-right: 60px;
}

.scale-wrapper .scale-horizontal .scale .scale-line-wrapper {
    position: relative;
    height: 60px;
}

.scale-wrapper .scale-horizontal .scale .scale-line-wrapper .click-area {
    height: 60px;
    width: calc(100% + 60px);
    top: 0;
    cursor: pointer;
    left: -30px;
}

.scale-wrapper .scale-horizontal .scale .scale-line-wrapper .scale-line {
    height: 1px;
    position: absolute;
    top: 30px;
    left: 0;
    background: #000;
    width: 100%;
}

.scale-wrapper .scale-horizontal .scale .tick {
    position: absolute;
    top: 26px;
    height: 9px;
    width: 1px;
    background: #000;
}

.scale-wrapper .scale-horizontal .scale .tick.vertical-tick {
    display: none;
}

.scale-wrapper .scale-horizontal .scale .tick.first-tick {
    left: 0;
}

.scale-wrapper .scale-horizontal .scale .tick.last-tick {
    right: 0;
}

.scale-wrapper .scale-horizontal .scale .answer-marker-wrapper {
    top: 30px;
}

.scale-wrapper .scale-horizontal .descriptions {
    color: #666;
    position: relative;
    margin-bottom: 20px;
}

.scale-wrapper .scale-horizontal .descriptions .min-value-description {
    float: left;
    width: 40%;
    text-align: left;
    padding-left: 10px;
}

.scale-wrapper .scale-horizontal .descriptions .max-value-description {
    float: right;
    width: 40%;
    text-align: right;
    padding-right: 10px;
}

.scale-wrapper .scale-vertical {
    margin-top: 30px;
    margin-bottom: 40px;
}

.scale-wrapper .scale-vertical .value {
    left: 0;
    width: 50%;
    height: 20px;
    line-height: 20px;
    box-sizing: border-box;
    text-align: right;
    padding-right: 25px;
}

.scale-wrapper .scale-vertical .value.min-value {
    bottom: -10px;
}

.scale-wrapper .scale-vertical .value.max-value {
    top: -10px;
}

.scale-wrapper .scale-vertical .scale {
    height: 254px;
    width: 60px;
    position: relative;
    margin: 0px auto;
}

.scale-wrapper .scale-vertical .scale .scale-line-wrapper {
    position: absolute;
    top: 0px;
    left: 0;
    height: 254px;
    width: 60px;
    z-index: 1;

}

.scale-wrapper .scale-vertical .scale .scale-line-wrapper .scale-line {
    width: 1px;
    position: absolute;
    left: 30px;
    top: 0;
    background: #000;
    height: 100%;
}

.scale-wrapper .scale-vertical .scale .scale-line-wrapper .click-area {
    width: 60px;
    height: calc(100% + 60px);
    cursor: pointer;
    left: 0;
    top: -30px;
}

.scale-wrapper .scale-vertical .scale .tick {
    position: absolute;
    left: 26px;
    height: 1px;
    width: 9px;
    background: #000;
}

.scale-wrapper .scale-vertical .scale .tick.horizontal-tick {
    display: none;
}

.scale-wrapper .scale-vertical .scale .tick.first-tick {
    top: 0;
}

.scale-wrapper .scale-vertical .scale .tick.last-tick {
    bottom: 0;
}

.scale-wrapper .scale-vertical .scale .answer-marker-wrapper {
    left: 30px;
}

.scale-wrapper .scale-vertical .descriptions {
    position: absolute;
    right: 0;
    top: 0;
    width: 50%;
    text-align: left;
    padding-left: 20px;
    height: 100%;
    box-sizing: border-box;
    color: #666;
}

.scale-wrapper .scale-vertical .descriptions .max-value-description {
    top: -10px;
}

.scale-wrapper .scale-vertical .descriptions .min-value-description {
    bottom: -10px;
}

.scale-wrapper .scale-vertical .descriptions .description {
    max-height: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    position: absolute;
    left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/Components/Scale/Scale.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;;AAGA;IACI,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,MAAM;IACN,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,MAAM;IACN,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,aAAa;IACb,WAAW;IACX,UAAU;;AAEd;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,OAAO;IACP,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd","sourcesContent":[".scale-wrapper {\n    position: relative;\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.scale-wrapper.scale-wrapper-card-based {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n\n.scale-wrapper.scale-wrapper-top-border {\n    border-top: solid 1px var(--survey-border-color);\n}\n\n.scale-wrapper .scale-header {\n    text-transform: uppercase;\n    font-size: 14px;\n    text-align: left;\n    padding: 10px;\n    padding-left: 0px;\n    white-space: pre-wrap;\n}\n\n.scale-wrapper .selected-value-display {\n    font-size: 40px;\n    height: 45px;\n    line-height: 55px;\n    text-align: center;\n}\n\n.scale-wrapper .value {\n    position: absolute;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.scale-wrapper .scale-horizontal,\n.scale-wrapper .scale-vertical {\n    position: relative;\n}\n\n.scale-wrapper .scale-vertical:focus {\n    outline-offset: 10px;\n}\n\n.scale-wrapper .scale {\n    position: relative;\n}\n\n.scale-wrapper .scale .answer-marker-wrapper {\n    position: absolute;\n    width: 0px;\n    height: 0px;\n}\n\n.scale-wrapper .scale .answer-marker-wrapper .answer-marker {\n    position: absolute;\n    height: 26px;\n    width: 26px;\n    border-radius: 13px;\n    box-shadow: 0px 2px 5px #aaa;\n    background: #FFF;\n    z-index: 1;\n    pointer-events: none;\n    top: -13px;\n    left: -13px;\n}\n\n.scale-wrapper .scale .scale-line-wrapper {\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.scale-wrapper .scale .scale-line-wrapper .click-area {\n    position: absolute;\n    z-index: 1;\n}\n\n.scale-wrapper .scale-horizontal .value {\n    top: 0;\n    width: 60px;\n    height: 60px;\n    line-height: 60px;\n}\n\n.scale-wrapper .scale-horizontal .value.min-value {\n    left: 10px;\n    text-align: left;\n}\n\n.scale-wrapper .scale-horizontal .value.max-value {\n    right: 10px;\n    text-align: right;\n}\n\n.scale-wrapper .scale-horizontal .scale {\n    height: 60px;\n    margin-left: 60px;\n    margin-right: 60px;\n}\n\n.scale-wrapper .scale-horizontal .scale .scale-line-wrapper {\n    position: relative;\n    height: 60px;\n}\n\n.scale-wrapper .scale-horizontal .scale .scale-line-wrapper .click-area {\n    height: 60px;\n    width: calc(100% + 60px);\n    top: 0;\n    cursor: pointer;\n    left: -30px;\n}\n\n.scale-wrapper .scale-horizontal .scale .scale-line-wrapper .scale-line {\n    height: 1px;\n    position: absolute;\n    top: 30px;\n    left: 0;\n    background: #000;\n    width: 100%;\n}\n\n.scale-wrapper .scale-horizontal .scale .tick {\n    position: absolute;\n    top: 26px;\n    height: 9px;\n    width: 1px;\n    background: #000;\n}\n\n.scale-wrapper .scale-horizontal .scale .tick.vertical-tick {\n    display: none;\n}\n\n.scale-wrapper .scale-horizontal .scale .tick.first-tick {\n    left: 0;\n}\n\n.scale-wrapper .scale-horizontal .scale .tick.last-tick {\n    right: 0;\n}\n\n.scale-wrapper .scale-horizontal .scale .answer-marker-wrapper {\n    top: 30px;\n}\n\n.scale-wrapper .scale-horizontal .descriptions {\n    color: #666;\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.scale-wrapper .scale-horizontal .descriptions .min-value-description {\n    float: left;\n    width: 40%;\n    text-align: left;\n    padding-left: 10px;\n}\n\n.scale-wrapper .scale-horizontal .descriptions .max-value-description {\n    float: right;\n    width: 40%;\n    text-align: right;\n    padding-right: 10px;\n}\n\n.scale-wrapper .scale-vertical {\n    margin-top: 30px;\n    margin-bottom: 40px;\n}\n\n.scale-wrapper .scale-vertical .value {\n    left: 0;\n    width: 50%;\n    height: 20px;\n    line-height: 20px;\n    box-sizing: border-box;\n    text-align: right;\n    padding-right: 25px;\n}\n\n.scale-wrapper .scale-vertical .value.min-value {\n    bottom: -10px;\n}\n\n.scale-wrapper .scale-vertical .value.max-value {\n    top: -10px;\n}\n\n.scale-wrapper .scale-vertical .scale {\n    height: 254px;\n    width: 60px;\n    position: relative;\n    margin: 0px auto;\n}\n\n.scale-wrapper .scale-vertical .scale .scale-line-wrapper {\n    position: absolute;\n    top: 0px;\n    left: 0;\n    height: 254px;\n    width: 60px;\n    z-index: 1;\n\n}\n\n.scale-wrapper .scale-vertical .scale .scale-line-wrapper .scale-line {\n    width: 1px;\n    position: absolute;\n    left: 30px;\n    top: 0;\n    background: #000;\n    height: 100%;\n}\n\n.scale-wrapper .scale-vertical .scale .scale-line-wrapper .click-area {\n    width: 60px;\n    height: calc(100% + 60px);\n    cursor: pointer;\n    left: 0;\n    top: -30px;\n}\n\n.scale-wrapper .scale-vertical .scale .tick {\n    position: absolute;\n    left: 26px;\n    height: 1px;\n    width: 9px;\n    background: #000;\n}\n\n.scale-wrapper .scale-vertical .scale .tick.horizontal-tick {\n    display: none;\n}\n\n.scale-wrapper .scale-vertical .scale .tick.first-tick {\n    top: 0;\n}\n\n.scale-wrapper .scale-vertical .scale .tick.last-tick {\n    bottom: 0;\n}\n\n.scale-wrapper .scale-vertical .scale .answer-marker-wrapper {\n    left: 30px;\n}\n\n.scale-wrapper .scale-vertical .descriptions {\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 50%;\n    text-align: left;\n    padding-left: 20px;\n    height: 100%;\n    box-sizing: border-box;\n    color: #666;\n}\n\n.scale-wrapper .scale-vertical .descriptions .max-value-description {\n    top: -10px;\n}\n\n.scale-wrapper .scale-vertical .descriptions .min-value-description {\n    bottom: -10px;\n}\n\n.scale-wrapper .scale-vertical .descriptions .description {\n    max-height: 90px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n    position: absolute;\n    left: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
